import {ObituarySearchType} from "@/Pages/Obituary/Overview";

export interface OtherType {
  page: number,
}
/**
 * Take an object and return the get string with objects exploded
 * @param data
 */
export default function objectToSearchQuery(data: ObituarySearchType|OtherType) {


  return Object.entries(data).reduce((acc: any, [key, entry]) => {

    const prefix: string = acc.includes('?') ? '&' : '?'


    if (!entry){
      return acc;
    }
    if (key === 'places'){
      if (entry.length == 0){
        return acc;
      }
      return acc + prefix + entry.map((item: any) => `${key}[]=${item.value}`).join('&')
    }
    //array:  { name: ['one', 'two'] } to ?name[]=one&places[]=two
    if (entry.constructor === Array ) {
      // Skip empty arrays
      if (entry.length == 0){
        return acc;
      }
      return acc + prefix + entry.map(item => `${key}[]=${item}`).join('&')
    }


    // object to labeled array: { name: {value: 'first', label: 'First'}} to ?nameLabel=
    if (entry.constructor === Object && entry.hasOwnProperty('value')) {
      // flatten object using ->value
      return acc + prefix + key + 'Label=' + entry.label + '&' + key + '=' + entry.value
    }

    if (entry.constructor === Object && (entry.hasOwnProperty('day') || entry.hasOwnProperty('month') || entry.hasOwnProperty('year'))) {
      // flatten date object to 2001
      // return acc + prefix + key + 'Label=' + entry.label + '&' + key + '=' + entry.value
      let result = '';
      if (entry.hasOwnProperty('year')){
        result += entry.year
      }
      if (entry.hasOwnProperty('month')){
        result += '-' + (entry.month+1).toString().padStart(2, '0')
      }
      if (entry.hasOwnProperty('day')){
        result += '-' + (entry.day+1).toString().padStart(2, '0')
      }
      if (result.length > 0){
        return acc + prefix + key + '=' + result
      }
      return acc


    }

    // simple string
    if (entry) {
      return acc + prefix + key + '=' + entry
    }

    return acc

  }, '');
}
